export default __webpack_public_path__ + "static/media/A3_23.6681f9ac.mp3";